var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_vm._m(0),_c('p',[_vm._v("\n    Processando ... "),_c('span',[_vm._v(_vm._s(_vm.count)+"s")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n    Aguardando confirmação da compra"),_c('br'),_c('i',{staticClass:"el-icon-loading fa-3x"})])
}]

export { render, staticRenderFns }